<template>
  <div>
    <van-nav-bar class="backBox" :title="'信息收集'" />
    <div class="faceMain">
      <van-form @submit="onSubmit">
        <van-field
          v-model="form.username"
          name="username"
          label="姓名"
          placeholder="姓名"
          input-align="right"
          :rules="[
            { required: true, message: '姓名不能为空！', trigger: 'onBlur' },
          ]"
        />
        <van-field
          v-model="form.numID"
          name="numID"
          label="工号"
          placeholder="工号"
          input-align="right"
          :rules="[
            { required: true, message: '工号不能为空！', trigger: 'onBlur' },
          ]"
        />
        <van-field
          readonly
          clickable
          name="departmentValue"
          :value="departmentValue"
          label="部门"
          placeholder="点击选择部门"
          right-icon="arrow"
          @click="showDepartmentPicker = true"
          input-align="right"
        />
        <van-field
          readonly
          clickable
          name="teamGroupType"
          :value="teamGroupType"
          label="班组类型"
          placeholder="点击选择班组类型"
          right-icon="arrow"
          @click="showTeamGroupTypePicker = true"
          input-align="right"
        />
        <van-field
          readonly
          clickable
          name="teamGroupValue"
          :value="teamGroupValue"
          label="班组"
          placeholder="点击选择班组"
          right-icon="arrow"
          @click="showTeamGroupPicker = true"
          input-align="right"
        />

        <!-- <div></div> -->
        <div style="margin: 16px">
          <!-- <van-button round block type="info" @click="confirm">提交</van-button> -->
          <van-button round block type="info" native-type="submit"
            >下一步</van-button
          >
        </div>
      </van-form>
    </div>
    <van-popup v-model="showDepartmentPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="departmentPickerColumns"
        value-key="text"
        @confirm="onConfirmDepartmentPicker"
        @cancel="showDepartmentPicker = false"
      />
    </van-popup>
    <van-popup v-model="showTeamGroupPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="teamGroupPickerColumns"
        value-key="name"
        @confirm="onConfirmTeamGroup"
        @cancel="showTeamGroupPicker = false"
      />
    </van-popup>
    <van-popup v-model="showTeamGroupTypePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="teamGroupTypePickerColumns"
        value-key="name"
        @confirm="onConfirmTeamGroupType"
        @cancel="showTeamGroupTypePicker = false"
      />
    </van-popup>
  </div>
</template>
<script>

// import FaceRecognition from './FaceRecognition.vue'
// import * as api from '../../api/api'
// import * as common from '../../api/common'
import * as utils from '../../api/utils'
import { Toast } from 'vant'
export default {
  components: {
    // FaceRecognition
  },
  data () {
    return {
      form: {
        username: '',
        numID: '',
        face: '',
        uploader: []
      },
      teamGroupValue: '',
      showTeamGroupPicker: false,
      teamGroupPickerColumns: ['班组1', '班组2', '班组3', '班组4', '班组5'],
      teamGroupType: '',
      showTeamGroupTypePicker: false,
      teamGroupTypePickerColumns: ['班组类型1', '班组类型2', '班组类型3', '班组类型4', '班组类型5'],
      teamGroupTypeID: null,
      teamGroupValueID: null,
      showDepartmentPicker: false,
      departmentValue: null,
      organizationData: [],
      oneDepartment: [],
      oneDepartmentID: null,
      twoDepartment: [],
      twoDepartmentID: null,
      threeDepartment: [],
      threeDepartmentID: null,
      departmentPickerColumns: [

      ]
    }
  },
  beforeRouteEnter (to, from, next) {
    console.log('to', to.path)
    if (from.path !== '/catchFace') {
      // localStorage.removeItem(common.keyFace)
      // api.setFaceCookie(common.keyFace, '', -1)
      // this.$store.commit(common.keyFace, null)
    }
    next()
  },
  mounted () {
    // this.teamGroupValue = this.teamGroupPickerColumns[0]
    // this.teamGroupType = this.teamGroupTypePickerColumns[0].name

    this.getTeamGroupType()
  },
  computed: {

  },
  methods: {
    // 下一步
    onSubmit (values) {
      console.log('submit', values)
      if (!this.teamGroupTypeID && !this.teamGroupValueID && !this.twoDepartmentID) {
        Toast.fail('部门不能为空')
        return
      }
      const para = {
        user_name: values.username,
        account: values.numID,
        grade_id: this.teamGroupTypeID,
        class: this.teamGroupValueID,
        campus: this.oneDepartmentID,
        department: this.twoDepartmentID,
        course_type: this.threeDepartmentID

      }

      sessionStorage.setItem('facePara', JSON.stringify(para))
      this.$router.push('/announcements')
    },
    onConfirmDepartmentPicker (value) {
      this.departmentValue = value[0] + '/' + value[1] + '/' + value[2]

      this.oneDepartmentID = this.oneDepartment.find(obj => obj.text === value[0]).id
      this.twoDepartmentID = this.twoDepartment.find(obj => obj.text === value[1]).id
      this.threeDepartmentID = this.threeDepartment.find(obj => obj.text === value[2]).id

      this.showDepartmentPicker = false
    },
    onConfirmTeamGroup (value) {
      this.teamGroupValue = value.name
      this.teamGroupValueID = value.id
      this.showTeamGroupPicker = false
    },
    onConfirmTeamGroupType (value) {
      this.teamGroupType = value.name
      this.teamGroupTypeID = value.id
      this.showTeamGroupTypePicker = false
      // 查询对应的班组信息
      this.getTeamGroup(value.id)
    },
    addFace () {

    },
    confirm () {

    },
    onClickLeft () {
      this.$router.go(-1)
    },
    async getTeamGroup (id) {
      const teamGroup = await utils.getTeamGroup(id)
      this.teamGroupPickerColumns = teamGroup
    },
    async getTeamGroupType () {
      const teamGroupType = await utils.getTeamGroupType()
      const organizationData = await utils.getOrganization()

      this.teamGroupTypePickerColumns = teamGroupType
      this.organizationData = organizationData
      const arr1 = []

      for (let x = 0; x < organizationData.length; x++) {
        this.oneDepartment.push({
          text: organizationData[x].name,
          id: organizationData[x].id,
          pid: organizationData[x].pid
        })
        arr1.push({
          text: organizationData[x].name,
          id: organizationData[x].id,
          pid: organizationData[x].pid,
          children: []
        })
        if (organizationData[x].children.length > 0) {
          for (let y = 0; y < organizationData[x].children.length; y++) {
            this.twoDepartment.push({
              text: organizationData[x].children[y].name,
              id: organizationData[x].children[y].id,
              pid: organizationData[x].children[y].pid
            })
            for (let m = 0; m < arr1.length; m++) {
              if (arr1[m].id === organizationData[x].children[y].pid) {
                arr1[m].children.push({
                  text: organizationData[x].children[y].name,
                  id: organizationData[x].children[y].id,
                  pid: organizationData[x].children[y].pid,
                  children: []
                })
              } else {
                arr1[m].children.push({
                  text: '',
                  id: '',
                  pid: '',
                  children: []
                })
              }

              if (organizationData[x].children[y].children.length > 0) {
                for (let z = 0; z < organizationData[x].children[y].children.length; z++) {
                  this.threeDepartment.push({
                    text: organizationData[x].children[y].children[z].name,
                    id: organizationData[x].children[y].children[z].id,
                    pid: organizationData[x].children[y].children[z].pid
                  })
                  for (let n = 0; n < arr1[m].children.length; n++) {
                    if (arr1[m].children[n].id === organizationData[x].children[y].children[z].pid) {
                      arr1[m].children[n].children.push({
                        text: organizationData[x].children[y].children[z].name,
                        id: organizationData[x].children[y].children[z].id,
                        pid: organizationData[x].children[y].children[z].pid

                      })
                    } else {
                      arr1[m].children[n].children.push({
                        text: '',
                        id: '',
                        pid: ''

                      })
                    }
                  }
                }
              }
            }
          }
        }
      }

      this.departmentPickerColumns = arr1
    }

  }
}
</script>
<style  scoped lang="scss">
.faceMain {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.addFaceBox {
  z-index: 999;
  background-color: #fff;
}
.faceBox {
  /* width: 100%; */
  padding: 10px 16px;
  display: flex;
  align-content: center;
  justify-content: space-between;
  align-items: center;
  .lableTitle {
    font-size: 14px;
    color: #646566;
    width: 6.2rem;
  }
}
.faceImgBox {
  width: 80%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // flex-direction: column;
}
</style>
